import { Injectable, signal } from '@angular/core';

type ConnectionStatus = 'common.online' | 'common.offline';

const STORAGE_KEY = 'connection_status';

@Injectable({ providedIn: 'root' })
export class ConnectionStatusService {
  readonly status = signal<ConnectionStatus>(this.restoreStatus());

  setOffline(): void {
    this.persist('common.offline');
  }

  setOnline(): void {
    this.persist('common.online');
  }

  private persist(value: ConnectionStatus): void {
    localStorage.setItem(STORAGE_KEY, value);
    this.status.set(value);
  }

  private restoreStatus(): ConnectionStatus {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'common.offline' ? 'common.offline' : 'common.online';
  }
}
